<template>
  <div class="additionalFile">
    <div id="pdfContainer" ref="pdfContainer"></div>
    <p v-if="!pdfUrl">Ładowanie PDF...</p>
  </div>
</template>

<script>
import * as pdfjsLib from "pdfjs-dist";
import "pdfjs-dist/build/pdf.worker.entry";
import { useStore } from "../../store";
import httpActions from "../../plugins/httpActionService";

export default {
  data() {
    return {
      pdfUrl: null,
      renderAbortController: null,
    };
  },
  computed: {
    mainAdditionalFile() {
      return useStore().mainAdditionalFile[0];
    },
  },
  async mounted() {
    if (this.mainAdditionalFile) {
      await this.checkCacheOrLoadPdf(this.mainAdditionalFile);
    }
  },
  methods: {
    async checkCacheOrLoadPdf(file) {
      const cachedBlobUrl = await this.getCachedPdf(file.url);
      if (cachedBlobUrl) {
        this.pdfUrl = cachedBlobUrl;
        this.renderPdf(cachedBlobUrl);
      } else {
        await this.loadPdf(file);
      }
    },

    async clearCorruptCache() {
      const db = await this.openDb();
      const transaction = db.transaction("pdfCache", "readwrite");
      const store = transaction.objectStore("pdfCache");
      store.clear();
    },

    async loadPdf(file) {
      try {
        const response = await httpActions.getAdditionalFile(file.url, file.mimeType, file.extension);
        const blob = new Blob([response], { type: file.mimeType });
        const blobUrl = URL.createObjectURL(blob);

        this.pdfUrl = blobUrl;
        await this.savePdfToCache(file.url, blob);
        this.renderPdf(blobUrl);
      } catch (error) {
        this.clearCorruptCache();
        console.error("Błąd podczas pobierania pliku PDF:", error);
      }
    },

    async renderPdf(pdfUrl) {
      if (this.renderAbortController) {
        this.renderAbortController.abort();
      }
      this.renderAbortController = new AbortController();
      const { signal } = this.renderAbortController;
      const loadingTask = pdfjsLib.getDocument(pdfUrl);
      const pdf = await loadingTask.promise;
      const pdfContainer = this.$refs.pdfContainer;
      pdfContainer.innerHTML = "";

      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        if (signal.aborted) {
          console.warn("Renderowanie anulowane przez AbortController");
          return;
        }

        const page = await pdf.getPage(pageNum);
        const canvas = document.createElement("canvas");
        pdfContainer.appendChild(canvas);
        const context = canvas.getContext("2d");
        const viewport = page.getViewport({ scale: 2 });
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        await page.render({ canvasContext: context, viewport }).promise;
      }
    },

    async savePdfToCache(url, blob) {
      const db = await this.openDb();
      const transaction = db.transaction("pdfCache", "readwrite");
      const store = transaction.objectStore("pdfCache");
      store.put({ url, blob });
    },

    async getCachedPdf(url) {
      const db = await this.openDb();
      return new Promise((resolve) => {
        const transaction = db.transaction("pdfCache", "readonly");
        const store = transaction.objectStore("pdfCache");
        const request = store.get(url);
        request.onsuccess = () => {
          if (request.result) {
            resolve(URL.createObjectURL(request.result.blob));
          } else {
            resolve(null);
          }
        };
        request.onerror = () => {
          console.error("Błąd odczytu z cache");
          this.clearCorruptCache();
          resolve(null);
        };
      });
    },

    openDb() {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open("PdfCacheDB", 1);
        request.onupgradeneeded = (event) => {
          const db = event.target.result;
          db.createObjectStore("pdfCache", { keyPath: "url" });
        };
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
      });
    },
  },
  watch: {
    mainAdditionalFile(newval) {
      if (newval) {
        this.pdfUrl = null;
        setTimeout(() => {
          this.checkCacheOrLoadPdf(newval);
        }, 500);
      }
    },
  },
};
</script>
